export default {
  // container: {},
  container: {},
  right: {},
  main: {
    left: 400,
    marginLeft: 250,
  },
  main2: {
    paddingTop: 60,
  },
  button: {
    color: 'white',
  },
  dropdown: {
    color: 'white',
  },
  icon: {
    color: 'white',
  },
  title: {
    color: 'white',
    marginLeft: '200px',
    fontSize: '20px',
    verticalAlign: 'bottom',
    position: 'relative',
    top: '5px',
  },
  logo: {
    width: 150,
    paddingTop: 5,
  },
  appBar: {
    height: '40px',
    width: '130px',
    marginLeft: '10px',
  },
  appBar2: {
    position: 'fixed',
  },

  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    justifyContent: 'center',
  },
  employeeName: {
    textAlign: 'right',
  },
  tenantName: {
    textAlign: 'right',
    fontSize: 12,
  },
  upgrade: {
    marginLeft: 20,
    marginRight: 20,
  },
  warningIcon: {
    marginRight: 10,
  },
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/styles.js